import React from 'react';
import { motion } from 'framer-motion';
import { BadgeCheckIcon } from 'lucide-react';
import { HERO, PRICE } from '../constants/content';
import { PriceDisplay } from './PriceDisplay';
import { CtaButton } from './CtaButton';
import { StarRating } from './StarRating';
const HERO_SUBHEAD = 'El sistema completo para montar y hacer rentable tu pollería — con los mismos secretos del mostrador, ahora en tu celular.';
export function HeroSection() {
  return <section className="w-full bg-ink text-white" data-id="element-99" data-mp="2wltngpn5v7cx">
      <div className="mx-auto max-w-6xl px-4 py-10 sm:py-14" data-id="element-100" data-mp="30lkdgr4v5jge">
        {/* Title — rendered fully visible immediately (no opacity gate that
            could get stuck), so it's always legible on the dark background. */}
        <h1 className="mx-auto max-w-4xl text-center font-display text-2xl font-600 leading-tight text-white opacity-100 sm:text-4xl md:text-5xl" data-id="element-101" data-mp="2rrfoyed7ck41">
          {HERO.eyebrow}
        </h1>

        {/* Subhead (replaces the old video announcement) */}
        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="mx-auto mt-4 max-w-3xl text-center text-base leading-relaxed text-neutral-200 sm:text-lg" data-id="element-102" data-mp="2ffidvz57lhso">
          {HERO_SUBHEAD}
        </motion.p>

        {/* Hero image (replaces the old video placeholder) */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="mx-auto mt-8 max-w-4xl" data-id="element-103" data-mp="2z5c6ugjnu2yh">
          <div className="overflow-hidden rounded-2xl border-4 border-gold shadow-2xl" data-id="element-104" data-mp="1dpwtnzovpb3e">
            <picture data-id="element-105" data-mp="18r3em2ty1c14">
              <source type="image/webp" srcSet="https://cdn.magicpatterns.com/uploads/dNAxvt4iJR8QBiGYz6XZk3/1-600.webp 600w, https://cdn.magicpatterns.com/uploads/6Vcd7F3SdLRHGZCRiTrcwZ/1-1000.webp 1000w" sizes="(max-width: 768px) 100vw, 1000px" data-id="element-106" data-mp="18rv91abt13pt" />
              <img src="https://cdn.magicpatterns.com/uploads/6Vcd7F3SdLRHGZCRiTrcwZ/1-1000.webp" srcSet="https://cdn.magicpatterns.com/uploads/dNAxvt4iJR8QBiGYz6XZk3/1-600.webp 600w, https://cdn.magicpatterns.com/uploads/6Vcd7F3SdLRHGZCRiTrcwZ/1-1000.webp 1000w" sizes="(max-width: 768px) 100vw, 1000px" alt="Mostrador de pollería con cortes de pollo fresco y balanza" width={1290} height={2229} loading="eager" fetchPriority="high" decoding="async" className="h-auto max-h-[520px] w-full object-cover object-center" data-id="element-107" data-mp="3iqfvpp28ry3q" />
            </picture>
          </div>
        </motion.div>

        {/* Offer + CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="mx-auto mt-8 max-w-xl text-center" data-id="element-108" data-mp="23uxwe1wgr2r3">
          {/* Trust row */}
          <div className="mb-4 flex flex-col items-center justify-center gap-2 sm:flex-row" data-id="element-109" data-mp="1pwq3c52jsll7">
            <StarRating size={20} data-id="element-110" data-mp="2mk4f3ox9bucw" />
            <span className="text-sm font-600 text-neutral-200" data-id="element-111" data-mp="2ijklgvbw78vi">
              Cientos de polleros ya usando el sistema
            </span>
          </div>

          <div className="mb-4 inline-flex items-center gap-2 rounded-full bg-gold/20 px-3 py-1 text-sm font-700 uppercase tracking-wide text-gold-light" data-id="element-112" data-mp="2dr14dodzxvly">
            <BadgeCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-113" data-mp="369ez3f41d1gt" />
            Compra verificada · Pago único
          </div>

          <div className="mb-5" data-id="element-114" data-mp="31herd0hq549o">
            <span className="mb-1 block text-sm font-600 uppercase tracking-wide text-neutral-200" data-id="element-115" data-mp="31gc0gskej1tr">
              {HERO.offerLabel}
            </span>
            <PriceDisplay amount={PRICE.today} className="font-display text-5xl font-700 text-gold-light sm:text-6xl" symbolClassName="mr-0.5 align-top text-3xl" data-id="element-116" data-mp="2q2tkemq268zz" />
          </div>

          <CtaButton className="mb-3" data-id="element-117" data-mp="2h1c7tebv0pg1">{HERO.cta}</CtaButton>

          <a href="#oferta" className="mb-3 block text-sm font-600 text-gold-light underline-offset-4 hover:underline" data-id="element-118" data-mp="34qepunaeokb2">
            {HERO.ctaSub}
          </a>

          <p className="text-xs text-neutral-200" data-id="element-119" data-mp="2v1mzgjkzu829">{HERO.singlePayment}</p>
          <p className="mt-1 text-xs text-neutral-300" data-id="element-120" data-mp="2zzoix5mc09e9">{HERO.scarcity}</p>
        </motion.div>
      </div>
    </section>;
}